export default "__VITE_PUBLIC_ASSET__1100b93c__"